import { Skeleton } from "@/components/ui/skeleton";

/**
 * Loading skeleton for the AI assistant panel — DS-v2 screen-08 shimmer.
 *
 * Uses the existing `Skeleton` `variant="shimmer"` (the canonical
 * `.skeleton-shimmer` gradient sweep, TES-952/F5) to mirror the
 * "AI panel loading skeleton" state from the Stitch mock (INVENTORY §1
 * screen-08, §3 shimmer keyframe). Alternating left/right bubble widths
 * approximate a settling conversation while the session restores.
 */
export function AssistantSkeleton() {
  return (
    <div
      className="flex flex-1 flex-col gap-4 overflow-hidden p-4"
      aria-hidden="true"
      data-testid="assistant-skeleton"
    >
      {/* assistant bubble */}
      <div className="flex gap-3">
        <Skeleton variant="shimmer" className="h-8 w-8 shrink-0 rounded-full" />
        <Skeleton variant="shimmer" className="h-16 w-3/4 rounded-2xl rounded-bl-md" />
      </div>
      {/* user bubble */}
      <div className="flex flex-row-reverse gap-3">
        <Skeleton variant="shimmer" className="h-8 w-8 shrink-0 rounded-full" />
        <Skeleton variant="shimmer" className="h-10 w-1/2 rounded-2xl rounded-br-md" />
      </div>
      {/* assistant bubble */}
      <div className="flex gap-3">
        <Skeleton variant="shimmer" className="h-8 w-8 shrink-0 rounded-full" />
        <Skeleton variant="shimmer" className="h-24 w-5/6 rounded-2xl rounded-bl-md" />
      </div>
      {/* suggestion pills */}
      <div className="mt-auto flex flex-wrap gap-2">
        <Skeleton variant="shimmer" className="h-7 w-24 rounded-full" />
        <Skeleton variant="shimmer" className="h-7 w-32 rounded-full" />
        <Skeleton variant="shimmer" className="h-7 w-28 rounded-full" />
      </div>
    </div>
  );
}
